import { uniqBy } from 'lodash';

export class ForwarderMenuConfig {
  public defaults: any = {
    header: {
      self: {},
      items: [
        {
          title: $localize`:@@global.search:Search`,
          root: true,
          alignment: 'left',
          page: '/forwarder/search/forwarder-search',
          subPages: [
            '/forwarder/search/search-result',
            '/forwarder/search/quote-cart',
          ],
        },
        {
          title: $localize`:@@global.quotes:Quotes`,
          root: true,
          alignment: 'left',
          toggle: 'click',
          submenu: [
            {
              title: $localize`:@@menu-config.airline:Airline`,
              page: '/forwarder/quote/quote-status',
            },
            {
              title: $localize`:@@menu-config.shipper:Shipper`,
              page: '/forwarder/quote/shipper-quote',
            },
          ],
        },
        {
          title: $localize`:@@global.shipments:Shipments`,
          root: true,
          alignment: 'left',
          page: '/forwarder/book/booking-history',
        },
        {
          title: $localize`:@@global.allotment:Allotment`,
          root: true,
          alignment: 'left',
          page: '/forwarder/allotment',
        },
        {
          title: $localize`:@@global.rates:Rates`,
          root: true,
          alignment: 'left',
          toggle: 'click',
          submenu: [
            {
              title: $localize`:@@global.compare-rates:Compare rates`,
              page: '/forwarder/compare-rates',
            },
            {
              title: $localize`:@@global.airlines-rate-sheet:Airline rate sheets`,
              page: '/forwarder/rate-sheet',
            },
            {
              title: $localize`:@@global.local-charges:Local charges`,
              page: '/forwarder/local-charge',
            },
          ],
          subPages: [
            '/forwarder/contract-rate',
            '/forwarder/contract-promo-rate',
            '/forwarder/market-rate',
            '/forwarder/promo-rate',
          ],
        },
        {
          title: $localize`:@@global.dashboards:Dashboards`,
          root: true,
          alignment: 'left',
          toggle: 'click',
          submenu: [
            {
              title: $localize`:@@global.reports:Reports`,
              page: '/forwarder/dashboard/reports',
            },
            {
              title: $localize`:@@global.market-analysis:Market analysis`,
              page: '/forwarder/dashboard/market-analysis',
            },
            {
              title: $localize`:@@global.airline-contact:Airline contacts`,
              page: '/forwarder/dashboard/airline-contacts',
            },
            {
              title: $localize`:@@global.quotation:Quotation`,
              page: '/forwarder/dashboard/quotation',
            },
          ],
        },
      ],
    },
  };

  public get menuItems(): any {
    this.defaults.header.items = uniqBy(this.defaults.header.items, 'title');
    return this.defaults;
  }
}
